import Svg, { Path } from 'react-native-svg';

export function HideIcon({ width, height, color = '#FFFFFF' }: any) {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none">
        <Path 
            d="M3 3L21 21" 
            stroke={color}
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <Path 
            d="M13.7345 13.7331C13.5098 13.9743 13.2388 14.1677 12.9378 14.3019C12.6367 14.436 12.3116 14.5082 11.9821 14.514C11.6525 14.5198 11.3251 14.4592 11.0195 14.3357C10.7139 14.2123 10.4362 14.0285 10.2031 13.7955C9.97007 13.5624 9.78632 13.2847 9.66287 12.9791C9.53942 12.6735 9.47879 12.3461 9.48461 12.0165C9.49042 11.687 9.56256 11.3619 9.69672 11.0608C9.83087 10.7598 10.0243 10.4888 10.2655 10.2641M16.86 16.8586C15.4614 17.9247 13.7584 18.5153 12 18.5441C6.27273 18.5441 3 11.9986 3 11.9986C4.01773 10.102 5.42929 8.44492 7.14 7.1386L16.86 16.8586ZM10.2818 5.64951C10.845 5.51768 11.4216 5.45179 12 5.45315C17.7273 5.45315 21 11.9986 21 11.9986C20.5033 12.9277 19.911 13.8025 19.2327 14.6086L10.2818 5.64951Z"
            stroke={color}
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Svg>
  );
};
